import React from 'react';
import styled from 'styled-components';
//
import BasicFormData from '../BasicFormData';
import ExtendedForm from './ExtendedForm';
import OpenNoNeedRadioButton from '../OpenNoNeedRadioButton';
import SendEmail from '../SendEmail';
import FixaceForm from '../FixaceForm';
import SplatnostForm from '../SplatnostForm';

export default class LoansForm extends React.Component {
  state = {
    name: '',
    ico: '',
    jednotka: '',
    nesplacenajistina: '',
    mesicniSplatka: '',
    ucelUveru: '',
    splatka: '',
    prijem: '',
    cerpani: '',
    refinancovani: '',
    open: 'ano',
    tel: '',
    email: '',
    terminkoncefixace: '',
    threeYears: false,
    fiveYears: false,
    tenYears: false,
    fiveteenYears: false,
    jine: false,
    year5: false,
    year10: false,
    year15: false,
    year20: false,
    year25: false,
    fondOprav: false,
    mesicniSplatky: false,
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleChecked = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  render() {
    const {
      name,
      ico,
      jednotka,
      tel,
      email,
      nesplacenajistina,
      ucelUveru,
      splatka,
      prijem,
      refinancovani,
      cerpani,
      open,
      terminkoncefixace,
      threeYears,
      fiveYears,
      tenYears,
      fiveteenYears,
      jine,
      year5,
      year10,
      year15,
      year20,
      year25,
      fondOprav,
      mesicniSplatky,
      mesicniSplatka,
    } = this.state;

    const data = {
      formName: 'Refinancování',
      jmeno: name,
      ico,
      jednotka,
      tel,
      email,
      splatka,
      mesicniSplatka,
      fixace: terminkoncefixace,
      delkaFixace: {
        threeYears,
        fiveYears,
        tenYears,
        fiveteenYears,
        jine,
      },
      splatnostUveru: {
        year5,
        year10,
        year15,
        year20,
        year25,
        fondOprav,
        mesicniSplatky,
      },
    };

    return (
      <PageContainer>
        <h1>Schůzka k refinancování</h1>
        <Form>
          <form noValidate autoComplete='off'>
            <BasicFormData
              ico={ico}
              jednotka={jednotka}
              name={name}
              tel={tel}
              email={email}
              onChange={this.handleChange}
            />
            <OpenNoNeedRadioButton open={open} onOpenNoNeed={this.handleChange('open')} />
            {open === 'ano' ? (
              <React.Fragment>
                <ExtendedForm
                  nesplacenajistina={nesplacenajistina}
                  ucelUveru={ucelUveru}
                  splatka={splatka}
                  prijem={prijem}
                  cerpani={cerpani}
                  onChange={this.handleChange}
                  refinancovani={refinancovani}
                  terminkoncefixace={terminkoncefixace}
                  mesicniSplatka={mesicniSplatka}
                />
                <FixaceForm
                  fiveYears={fiveYears}
                  tenYears={tenYears}
                  fiveteenYears={fiveteenYears}
                  threeYears={threeYears}
                  jine={jine}
                  onChecked={this.handleChecked}
                  title='Požadovaná délka fixace úrokové sazby:'
                />
                <SplatnostForm
                  onChecked={this.handleChecked}
                  year5={year5}
                  year10={year10}
                  year15={year15}
                  year20={year20}
                  year25={year25}
                  fondOprav={fondOprav}
                  mesicniSplatky={mesicniSplatky}
                />
              </React.Fragment>
            ) : null}
            <SendEmail data={data} disabled={(name && ico && jednotka && tel && email).length < 1} />
          </form>
        </Form>
      </PageContainer>
    );
  }
}

const Form = styled.div`
  width: 100%;
  max-width: 600px;
  padding: 12px;
  display: flex;
  margin: 0 auto;
  flex-direction: column;
`;
const PageContainer = styled.div`
  padding: 24px;
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;
  h1 {
    margin-bottom: 12px;
  }
  @media (max-width: 450px) {
    padding: 24px 2%;
  }
`;
